let currentPage = 1;
let lastPage = null;
let isLoading = false;
let currentTrainingId = null;

function generateStars(score) {
    if (!score || score === 0) return 'n.v.t.';
  
    const stars = score / 2;
    const whole = Math.floor(stars);
    const decimal = stars - whole;
  
    let html = '';
    for (let i = 0; i < whole; i++) html += '<i class="fas fa-star"></i>';
    if (decimal > 0.2 && decimal < 0.7) {
      html += '<i class="fas fa-star-half"></i>';
    } else if (decimal >= 0.7) {
      html += '<i class="fas fa-star"></i>';
    }
    return html;
  }

function loadReviews(id, append = false) {
  if (isLoading || (lastPage !== null && currentPage > lastPage)) return;

  isLoading = true;

  if (append) {
    document.querySelector('#lazyLoadingIndicator .loading-text').style.opacity = '1';
  } else {
    document.getElementById('reviewLoader').style.display = 'block';
  }

  console.log(JSON.stringify({ id, page: currentPage }));
  fetch('/reviews-ophalen', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    },
    body: JSON.stringify({ id, page: currentPage })
  })
    .then(response => response.json())
    .then(data => {
      const contentContainer = document.getElementById('reviewContent');
      const template = document.getElementById('reviewTemplate');

      if (!append) contentContainer.innerHTML = '';

      data.reviews.forEach(review => {
        const clone = template.content.cloneNode(true);

        clone.querySelector('.training__reviews__item__title').textContent = review.cursist;
        clone.querySelector('.training__reviews__item__date').textContent = review.datum;
        clone.querySelector('.training__reviews__item__training').textContent = review.training;
        clone.querySelector('.training__reviews__item__score__number').textContent = review.beoordeling_training_algemeen ?? 'n.v.t.';
        clone.querySelector('.training__reviews__item__score__stars').innerHTML = generateStars(review.beoordeling_training_algemeen);
        clone.querySelector('.training__reviews__item__text').textContent = review.open_goed_aan_training ?? '';

        // Aanbeveling bij score >= 8
        if (review.beoordeling_training_algemeen >= 8) {
        const recommend = clone.querySelector('.training__reviews__item__recommend');
        recommend.style.display = 'flex';
        recommend.querySelector('.recommend-label').textContent =
            `Ja ik raad deze ${review.training.toLowerCase().includes('opleiding') ? 'opleiding' : 'training'} aan`;
        }

        // Sub-ratings
        clone.querySelector('.rating-opbouw').innerHTML = generateStars(review.beoordeling_trainingopbouw);
        clone.querySelector('.rating-inhoud').innerHTML = generateStars(review.beoordeling_training_algemeen); // let op: inhoud ≠ algemeen?
        clone.querySelector('.rating-praktijk').innerHTML = generateStars(review.beoordeling_oef_aansluiten_op_praktijk);
        clone.querySelector('.rating-trainer').innerHTML = generateStars(review.beoordeling_presentatie_docent);
        clone.querySelector('.rating-lunch').innerHTML = generateStars(review.beoordeling_lunch);

        contentContainer.appendChild(clone);
      });

      lastPage = data.last_page;
      currentPage = data.current_page + 1;
    })
    .catch(error => {
      console.error(error);
    })
    .finally(() => {
      isLoading = false;
      document.getElementById('reviewLoader').style.display = 'none';
      document.querySelector('#lazyLoadingIndicator .loading-text').style.opacity = '0';

      if (currentPage > lastPage) {
        document.getElementById('lazyLoadingIndicator').style.display = 'none';
      }
    });
}
document.addEventListener('DOMContentLoaded', function () {
    const drawer = document.getElementById('education-review-drawer');

    // Klik op trigger om drawer te openen
    document.querySelectorAll('[data-open="education-review-drawer"]').forEach(trigger => {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();

            currentTrainingId = trigger.getAttribute('data-id');
            currentPage = 1;
            lastPage = null;

            document.getElementById('reviewContent').innerHTML = '';
            document.getElementById('reviewLoader').style.display = 'block';
            document.getElementById('lazyLoadingIndicator').style.display = 'block';

            drawer.style.display = 'block'; // open drawer
            loadReviews(currentTrainingId);
        });
    });

    // Lazy load op scroll
    drawer.addEventListener('scroll', function () {
        if (drawer.scrollTop + drawer.clientHeight >= drawer.scrollHeight - 100) {
            loadReviews(currentTrainingId, true);
        }
    });
});